export class SysConfig {
  constructor(
    public app_protected: boolean,
    public wp_news_url: string,
    public wp_help_url: string,
    public wp_rest: string,
  ) {
  }
}
